<template>
  <div id="vista-seleccion-plantilla-personalizada" v-if="acuerdo_comercial_copy">
    <div class="pa-6">
      <div class="titulo-principal mb-6">Configuración del acuerdo</div>
      <v-form
        ref="formulario_vista_seleccion_plantilla_personalizada"
        onSubmit="return false;"
      >

        <!-- Consorcio destinado, si es libre [acuerdo_libre - no esta en uso actualmente] -->
        <div v-if="acuerdo_comercial_copy.tipo_acuedo === TIPO_ACUERDO_LIBRE">
          <v-text-field
            label="Consorcio"
            placeholder="Nombre del consorcio"
            v-model="acuerdo_comercial_copy.consorcio_propuesta_libre"
            counter="64"
            clearable
            :rules="regla_titulo_consorcio"
            required
          >
          </v-text-field>
        </div>

        <opcion-plantilla-personalizada
          ref="opcion_plantilla_personalizada"
          :plantillas="plantillas"
          :acuerdo_comercial.sync="acuerdo_comercial_copy"
        >
        </opcion-plantilla-personalizada>

      </v-form>
    </div>
  </div>
</template>

<script>
import { AcuerdoComercial } from '../../../../models/AcuerdoComercial';
import * as acuerdo_comercial_constantes from '../../acuerdo-comercial.consts';
import OpcionPlantillaPersonalizada from '../OpcionPlantillaPersonalizada.vue';

export default {
  name:'VistaSeleccionPlantillaPersonalizada',
  components: {
    OpcionPlantillaPersonalizada,
  },
  props: {
    acuerdo_comercial: { type: AcuerdoComercial, default: null },
    plantillas: { type: Array, default: () => [] },
  },
  data: () => ({
    acuerdo_comercial_copy: null,

    regla_titulo_consorcio: [
      titulo => !!titulo || 'El nombre del consorcio es requerido',
      titulo => (titulo && titulo.length <= 64) || 'El nombre del consorcio no puede superar los 64 caracteres'
    ],

    // Constantes usadas en el template
    TIPO_ACUERDO_LIBRE: acuerdo_comercial_constantes.TipoAcuerdo.LIBRE, //[acuerdo_libre - no esta en uso actualmente]
    TIPO_ACUERDO_POR_DEFECTO: acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION,
    TIPO_ACUERDO_VINCULADO_AL_CONSORCIO: acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO
  }),
  /**
   * Al montarse el componente, se crea una copia deep del AC original, para modificarla.
   */
  mounted(){
    this.acuerdo_comercial_copy = _.cloneDeep(this.acuerdo_comercial);
  },
  methods:{
    /**
     * Metodo invocado desde el padre, para validar el formulario
     * En caso que el formulario sea valido, se actualiza el acuerdo comercial
     */
    validarFormulario(){
      let valido = true;

      // [acuerdo_libre - no esta en uso actualmente]
      let consorcio_propuesta_libre = this.acuerdo_comercial_copy.consorcio_propuesta_libre; // me guardo el nombre del consorcio destinado, porque la siguiente linea me actualiza el AC con la opción que selecciono.

      valido = this.$refs.formulario_vista_seleccion_plantilla_personalizada.validate(); // Actualiza el AC

      // Seteo el nombre del consorcio destinado solo en caso que sea libre y haya pasado la validación del formulario [acuerdo_libre - no esta en uso actualmente]
      if(valido && this.acuerdo_comercial_copy.tipo_acuedo === this.TIPO_ACUERDO_LIBRE){

        valido = !!this.acuerdo_comercial_copy.consorcio_propuesta_libre;
        this.acuerdo_comercial_copy.consorcio_propuesta_libre = consorcio_propuesta_libre;
      }

      this.$emit('update:acuerdo_comercial', this.acuerdo_comercial_copy);

      return valido;
    },
  },
};
</script>

<style lang="scss">
#vista-seleccion-plantilla-personalizada{

}
</style>